export default __webpack_public_path__ + "static/media/MeasuresSmallIllustration.1bc9d5b2.svg";